export class DatiUIU {
    sezione: string;
    foglio: string;
    numero: string;
    subalterno: string;
    superficieDpr: string;

    constructor() {
        this.sezione = null;
        this.foglio = null;
        this.numero = null;
        this.subalterno = null;
        this.superficieDpr = null;
    }
}